export default __webpack_public_path__ + "23.fb3b06.svg";